import React, { Component } from 'react';
import './App.css';
import Profile from '../components/user/Profile';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import map from '../components/Map';
import login from '../pages/login';
import signUp from '../pages/signup';
import user from '../pages/user';
import ReactGa from 'react-ga';
import { SET_AUTHENTICATED } from '../redux/types';
import { logoutUser, getUserData } from '../redux/actions/userActions';
import AuthRoute from './util/AuthRoute';
import Cart from './cart/cart';
import ConfirmOrder from './checkout/confirmOrder';

//REDUX
import { Provider } from 'react-redux';
import store from '../redux/store';
import axios from 'axios';

axios.defaults.baseURL =
  'https://us-central1-foodapp-f2809.cloudfunctions.net/api';

const token = localStorage.FBIdToken;

if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(logoutUser());
    window.location.href = '/login';
  } else {
    store.dispatch({ type: SET_AUTHENTICATED });

    axios.defaults.headers.common['Authorization'] = token;
    store.dispatch(getUserData());
  }
}

class App extends Component {
  componentDidMount() {
    //google analytics
    ReactGa.initialize('UA-176303273-1');
    ReactGa.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <Provider store={store}>
        <div>
          <div>
            <Router>
              <Switch>
                <Route exact path="/" component={map} />

                <AuthRoute exact path="/login" component={login} />
                <Route exact path="/Profile" component={Profile} />
                <AuthRoute exact path="/signup" component={signUp} />
                <Route exact path="/checkout/:handle" component={Cart} />

                <Route exact path="/:handle" component={user} />
                <Route
                  exact
                  path="/checkout/confirm/Chuys"
                  component={ConfirmOrder}
                />
              </Switch>
            </Router>
          </div>
        </div>
      </Provider>
    );
  }
}

export default App;
